module.exports = __webpack_public_path__ + "static/media/mailbox.c45b166c.svg";